import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import cx from 'classnames'

import { getEntityIconClassNames, getEntityText } from './helpers'

import './style.scss'

export default class EntityPreview extends Component {
    static propTypes = {
        entity: IPropTypes.map.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            animate: false,
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ animate: true })
        }, 0)
    }

    render() {
        const { entity } = this.props
        const { animate } = this.state

        const entityText = getEntityText(entity)

        return (
            <div className={cx('entity-wrap preview', animate && 'animate')}>
                <div className={cx('icon', getEntityIconClassNames(entity))} />
                <div className={'texts'}>
                    <div className={'name'}>{entity.get('name')}</div>
                    <div className={'text'}>{entityText}</div>
                    <div className={'address'}>{entity.get('address')}</div>
                </div>
            </div>
        )
    }
}
